export default "__VITE_ASSET__BD1WXCQV__"